import type { TankLook, UserInfo } from '@tanky/shared';

export const session: {
  me: UserInfo | null;
  look: TankLook | null;
  registration: 'open' | 'code' | 'closed';
  /** Smí upravovat knihovnu zvuků. */
  isAdmin: boolean;
} = {
  me: null,
  look: null,
  registration: 'open',
  isAdmin: false,
};

export interface Screen {
  el: HTMLElement;
  destroy(): void;
}

export function go(path: string) {
  location.hash = `#${path}`;
}
